import { render, staticRenderFns } from "./FormTakTertagih.vue?vue&type=template&id=9fca03ac&"
import script from "./FormTakTertagih.vue?vue&type=script&lang=js&"
export * from "./FormTakTertagih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports